export const SIGN_IN_PATH = '/sign-in'
export const HOME_PATH = '/home'
export const DOCUMENT_PATH = '/document'
export const OnlineSigningInfo_PATH = '/info'
